module.exports = __webpack_public_path__ + "premium_purchase_icon_3.png?fb1f20a12b7756e08fb4006c9affe38a";


//////////////////
// WEBPACK FOOTER
// ./static/img/premium_purchase_icon_3.png
// module id = 338
// module chunks = 0